import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { NumberFormatText } from "../../../../components/NumberFormatText";
import { RowBody } from "../../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../../components/ToolTip";
import { selectRcu } from "../../../../store/slices/aashtoSlice.js";

function Rcu() {
  const { t } = useTranslation("translation");

  const rcu = useSelector(selectRcu);
  const rcuFormula = "\\displaystyle R_{\\small{cu}} = \\Phi_{cu} \\cdot R_{n}";

  return (
    <RowBody
      titleValue={<p>{t("aashto.inner.Factored Compression Resistance")}</p>}
      indicesValue={
        <span>
          R<sub>CU</sub>
        </span>
      }
      inputValue={
        <span className="input">
          <NumberFormatText value={rcu} decimalScale={2} />
        </span>
      }
      unitValue={""}
      formulaValue={<ToolTip id={"rcuFormula"} type={IconType.FORMULA} formula={rcuFormula} />}
    />
  );
}

export default Rcu;
